import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

const Title = styled.div`
  ${({
    theme
  }) => css`
    display: block;
    padding: ${theme.spacing[2]} ${theme.spacing[1]};
    border-radius: 5px 5px 0 0;
    background-color: ${theme.colors.positive.hover};
    color: ${theme.colors.buy.hover};
    text-align: center;
    font-weight: ${theme.fontWeights.bold};
  `}
`;

const Wrapper = styled.div`
  ${({
    title,
    theme
  }) => css`
    padding-bottom: ${theme.spacing[2]};
    border-radius: 5px;
    border: solid 1px ${theme.colors.shades[5]};
    background-color: ${theme.colors.shades[7]};
    overflow: hidden;
  `};  
`;

/**
 * @tags styled, card
 */
const Card = props => (
  <Wrapper className={`dc-card ${props.className}`} data-qa={props.qa}>
    <Title className="dc-card__title">{props.title}</Title>
    <div className="dc-card__content">{props.children}</div>
  </Wrapper>
);

Card.propTypes = {
  className: PropTypes.string,
  title: PropTypes.PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  qa: PropTypes.string
};

Card.defaultProps = {
  className: undefined,
  qa: undefined
};

Card.displayName = 'Card';

export default Card;
